import { getWeather, graphqlCall } from '@akin-home/amplify';
import { OpenWeatherV2Response } from '@akin-home/weather';

interface Params {
  latitude?: number;
  longitude?: number;
  location?: string;
  date?: string;
}

export const getWeatherQuery = async (params: Params) => {
  const data = (await graphqlCall(getWeather, params)).data.getWeather;

  // Check that data is set and not empty
  if (data && data.length > 2) {
    return JSON.parse(data) as OpenWeatherV2Response;
  }

  return undefined;
};
